import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import VendorBundleTable from './VendorBundleTable';
import VendorBundleEditView from './VendorBundleEditView';

const VendorBundlesView = () => (
  <Routes>
    <Route element={<VendorBundleEditView />} path="/new" />
    <Route element={<VendorBundleEditView />} path="/:pkEcomVendorBundle" />
    <Route
      element={<VendorBundleEditView duplicate />}
      path="/:pkEcomVendorBundle/duplicate"
    />
    <Route element={<VendorBundleTable />} path="/" />
    <Route
      element={<Navigate replace to="/vendor/product-bundles" />}
      path="*"
    />
  </Routes>
);

export default VendorBundlesView;
